module.exports = __webpack_public_path__ + "static/Dona-Regular-1d75aef8f4e6c1a0aef1cd11ad89f550.eot";